import { initBrowserSentry, defaultTracesSampleRate } from 'app-core'
import type { createRouter } from '@src/router'
import { ENV } from '@src/config/env'

export const initDevicesSentry = (router: ReturnType<typeof createRouter>) => {
  if (!ENV.SENTRY_ENABLED || !ENV.SENTRY_DSN) {
    return
  }

  const isProduction = ENV.API_ENV === 'PROD'

  initBrowserSentry({
    router,
    dsn: ENV.SENTRY_DSN,
    enabled: true,
    isProduction,
    environment: isProduction ? 'production' : ENV.API_ENV.toLowerCase(),
    options: {
      tracesSampleRate: defaultTracesSampleRate(isProduction),
    },
  })
}
